import { FC, useState } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { ErrorFallback } from "@/components";
import { useSubmissions } from "@/features/submissions/hooks/useSubmission";
import { Spinner } from "@radix-ui/themes";
import SubmissionsUI from "./submissions.ui";

const SubmissionsFetcher: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Submissions");
  const [status, setStatus] = useState<"approved" | "rejected" | "pending">(
    "pending"
  );

  const { data, loading, error } = useSubmissions(status);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorFallback>Error: {error.message}</ErrorFallback>;
  }

  return <SubmissionsUI data={data} setStatus={setStatus} status={status} />;
};

export default SubmissionsFetcher;
